import { Log } from '@/parsing/Log';
import { LogEntryType } from '@/parsing/LogEntry';
import { TRUNCATED_MARKER } from '@/parsing/parsers/reactnative/ReactNativeLogParser';
import { ReactNativeLogEntryData } from '@/parsing/parsers/reactnative/types';

import { TimelineMarker, TimelineRow, TimelineRowGroup } from '../../TimelineData';
import { obtainFreeRowForMarker } from '../obtainFreeRowForMarker';
import { TimelineGeneratorContext } from '../TimelineGeneratorContext';

export function generateReduxActionGroupFromLog(
  log: Log,
  ctx: TimelineGeneratorContext,
): TimelineRowGroup {
  const rows: TimelineRow[] = [];

  for (const entry of log.entries) {
    if (entry.entryType !== LogEntryType.ReduxAction) {
      continue;
    }

    try {
      let jsonStr = entry.content;
      if (jsonStr.endsWith(TRUNCATED_MARKER)) {
        jsonStr = jsonStr.slice(0, -TRUNCATED_MARKER.length);
      }
      const rnLogEntry: ReactNativeLogEntryData<'reduxAction'> = JSON.parse(jsonStr).data;
      const rdxActionType: string | undefined = rnLogEntry.type;
      if (!rdxActionType) {
        continue;
      }

      const tooltipContent = `${rdxActionType}\n${
        JSON.stringify(rnLogEntry.payload, null, 2) ?? '{}'
      }`;
      let textOnMarker = '';
      let fillColor = '';
      let textOnMarkerColor = '';

      if (rdxActionType) {
        if (rdxActionType.includes('/')) {
          textOnMarker = `${rdxActionType.split('/').slice(1).join('/').toLowerCase()}`;
        } else {
          textOnMarker = `${rdxActionType.toLowerCase()}`;
        }
        fillColor = '#b2e9f8';
        textOnMarkerColor = '#4f7476';
      } else {
        continue;
      }

      const marker: TimelineMarker = {
        markerId: ctx.nextMarkerId,
        logEntry: entry,
        startTimeMs: entry.date.getTime(),
        endTimeMs: undefined,
        fillColor,
        textOnMarker,
        textOnMarkerColor,
        tooltipContent,
      };
      ctx.nextMarkerId += 1;

      const row = obtainFreeRowForMarker(rows, marker);
      row.markers.push(marker);
    } catch (error) {
      console.error('Cannot parse JSON for Redux Action timeline', entry.content, error);
      continue;
    }
  }

  const rowGroup: TimelineRowGroup = {
    name: 'Redux actions',
    rows,
    expanded: false,
  };
  return rowGroup;
}
